import { StrictMode } from "react";
import ReactDOM from "react-dom";
import AuthProvider from "@poseidon/ui/components/AuthContext";
import { LocalizationProvider } from "@mui/lab";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { BrowserRouter } from "react-router-dom";
import AdminApp from "./app/App";
import { isSupported } from "firebase/messaging";
import { messaging } from "@poseidon/firebase/firebase";
import { getToken, onMessage } from "firebase/messaging";

// Extend the Window interface to include enableNotifications
declare global {
  interface Window {
    enableNotifications: () => Promise<void>;
  }
}

ReactDOM.render(
  <StrictMode>
    <AuthProvider profileCollection="admins" requiresClaim="admin">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <BrowserRouter>
          <AdminApp />
        </BrowserRouter>
      </LocalizationProvider>
    </AuthProvider>
  </StrictMode>,
  document.getElementById("root")
);

let swReg: ServiceWorkerRegistration | undefined;

// Register service worker for PWA/offline support
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        swReg = registration;
        console.log("Service Worker registered: ", registration);
      })
      .catch((registrationError) => {
        console.log("Service Worker registration failed: ", registrationError);
      });
  });
}

async function enableNotifications() {
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    console.log("Notifications permission not granted");
    return;
  }

  // Use the VAPID key from Firebase Console → Cloud Messaging → Web Push certificates
  const vapidKey =
    "BJZDKfhmyurEkHi5KUDf4_riH4fRD25SGD8qy6Wjderjtei0HpdTXaZCuJzuW4U8bwn-tvT7L4esDq0rg8EApfY";

  const token = await getToken(messaging, {
    vapidKey,
    serviceWorkerRegistration: swReg, // ensures background messages route to your SW
  });

  if (token) {
    console.log("FCM token:", token);
    // TODO: send token to your backend and associate with the signed-in user
    await fetch("/api/store-fcm-token", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });
  } else {
    console.log("No registration token retrieved");
  }
}

(async () => {
  if (await isSupported()) {
    // Foreground messages (tab is open & focused)
    onMessage(messaging, (payload) => {
      console.log("Message received in foreground:", payload);
      // Optionally show an in-app toast/notification
    });

    // expose function or bind to a button
    window.enableNotifications = enableNotifications;
  } else {
    console.log("FCM not supported in this browser");
  }
})();
